import VirtualBackgroundExtension from 'agora-extension-virtual-background';
import AgoraRTC from 'agora-rtc-sdk-ng';
import logger from '@/modules/Logger';

// Singleton: register extension once globally, reuse across adapter instances
const vbExtension = new VirtualBackgroundExtension();
AgoraRTC.registerExtensions([vbExtension]);

export { vbExtension };

export default {
  async initVirtualBackground() {
    try {
      this.vbExtension = vbExtension;

      // Skip initialization if browser doesn't support the extension
      if (!vbExtension.checkCompatibility()) {
        this.vbProcessorReady = false;
        return;
      }

      this.vbProcessor = vbExtension.createProcessor();

      await this.vbProcessor.init();
      this.vbProcessorReady = true;

      logger.info('[Agora] VB Extension initialized', {
        operation: 'vbackground:init'
      });
    } catch (error) {
      this.vbProcessorReady = false;
      logger.error('[Agora] VB Extension init failed', {
        operation: 'vbackground:init',
        reason: error.message,
        event_type: 78
      });
    }
  }
};
